import {
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
} from "../../../constants/constants";
import { toast } from "react-toastify";

function logoutRequest() {
  return {
    type: LOGOUT_REQUEST,
    isPending: true,
  };
}

function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS,
    userData: null,
    isPending: false,
    isAuthenticated: false,
    error: false,
  };
}

function logoutFailed() {
  return {
    type: LOGOUT_FAILURE,
    isPending: false,
    isAuthenticated: false,
    error: true,
  };
}

export const userLogout = (redirect, msg) => (dispatch) => {
  localStorage.removeItem("token");
  localStorage.removeItem("persist:root");
  window.sessionStorage.clear();

  dispatch(logoutSuccess());
  // notifikacije nakon odjave vise nisu potrebne
  // if (msg) {
  //   toast.info(msg, {
  //     position: toast.POSITION.BOTTOM_RIGHT,
  //   });
  // }

  redirect();
};
